import { SubjectLevel } from '@/resource/subject/subject.model';

const getLevel = (level: number) => {
  //NOTE: To handle for chapter that does nat has from (only by elementary, lowerform or upperform)
  if (level < 0) {
    // if (level === -1) {
    //   return SubjectLevel.Elementary;
    // } else
    if (level === -2) {
      return SubjectLevel.LowerForm;
    } else if (level === -3) {
      return SubjectLevel.UpperForm;
    }
  }

  let prefix = 'Year';

  if (level > 6) {
    prefix = 'Form';
    level -= 6;
  }

  return `${prefix} ${level}`;
};

export default getLevel;
